import { toast } from "sonner";
import { Plus, Pencil, Trash2 } from "lucide-react";
import { api, errorText } from "@/lib/api";
import { Panel } from "@/components/admin/shared";

export const CategoryManager = ({ categories, onChange }) => {
  const run = async (fn, msg) => { try { await fn(); toast.success(msg); onChange(); } catch (e) { toast.error(errorText(e)); } };
  const add = (parent_id) => {
    const name = window.prompt(parent_id ? "Nombre de la subcategoría" : "Nombre del nuevo grupo");
    if (name) run(() => api.post("/admin/gallery/categories", { name, parent_id }), "Categoría creada");
  };
  const rename = (c) => {
    const name = window.prompt("Nuevo nombre", c.name);
    if (name && name !== c.name) run(() => api.put(`/admin/gallery/categories/${c.id}`, { name }), "Categoría actualizada");
  };
  const del = (c) => {
    if (window.confirm(`¿Eliminar «${c.name}»${c.parent_id ? "" : " y sus subcategorías"}? Las fotos no se borran, quedan sin categoría.`)) run(() => api.delete(`/admin/gallery/categories/${c.id}`), "Categoría eliminada");
  };
  const Actions = ({ c }) => (
    <span className="ml-auto flex gap-1">
      <button onClick={() => rename(c)} aria-label="Renombrar" className="p-1 text-mute hover:text-ink" data-testid={`cat-rename-${c.id}`}><Pencil size={14} /></button>
      <button onClick={() => del(c)} aria-label="Eliminar" className="p-1 text-red-600" data-testid={`cat-delete-${c.id}`}><Trash2 size={14} /></button>
    </span>
  );
  return (
    <Panel title="Categorías" action={<button className="btn-ghost !px-3 !py-1.5 text-xs" onClick={() => add(null)} data-testid="cat-add-group-btn"><Plus size={14} /> Nuevo grupo</button>}>
      <div className="grid gap-4 md:grid-cols-2">
        {categories.filter((c) => !c.parent_id).map((g) => (
          <div key={g.id} className="rounded-sm border border-line p-3" data-testid={`cat-group-${g.id}`}>
            <p className="flex items-center font-bold uppercase">{g.name}<Actions c={g} /></p>
            <ul className="mt-2 space-y-1 text-sm">
              {categories.filter((c) => c.parent_id === g.id).map((c) => <li key={c.id} className="flex items-center">{c.name}<Actions c={c} /></li>)}
            </ul>
            <button className="mt-2 text-xs font-semibold text-gold" onClick={() => add(g.id)} data-testid={`cat-add-sub-${g.id}`}>+ Agregar subcategoría</button>
          </div>
        ))}
      </div>
    </Panel>
  );
};
